import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminDrafts from "@/pages/admin/AdminDrafts";

export const Route = createFileRoute("/admin/drafts")({
  head: () => pageHead("Admin \u2014 Drafts \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminDrafts,
});
